import { Stack, styled } from "@mui/material"

export const TooltipContainer = styled(Stack)({
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flex: 1,
    marginTop: 0,
})
